export const plainTextToParagraphHtml = (value) => {
    const lines = String(value ?? "")
        .split(/\r\n|\r|\n/)
        .map((line) => {
            const container = document.createElement("div");
            container.textContent = line;
            return container.innerHTML;
        });

    return `<p>${lines.join("<br />") || "<br />"}</p>`;
};